import React from 'react';

// Helper to import all images
const importAll = (r: any): string[] =>
  r.keys().map((key: string) => r(key).default || r(key));

const images: string[] = importAll(
  // @ts-ignore – ignore TypeScript complaining about require.context
  require.context('../assets/gallery', false, /\.(png|jpe?g|svg)$/)
);

const Gallery: React.FC = () => {
  return (
    <section className="section bg-cream">
      <div className="container-base">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="section-title">Our Gallery</h2>
          <p className="section-subtitle mx-auto px-4">
            A glimpse into the joy we create every day
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {images.map((image, index) => (
            <div
              key={index}
              className={`
                img-frame shadow-card
                ${index === 0 ? 'sm:col-span-2 sm:row-span-2' : ''}
                ${index === 5 ? 'hidden sm:block lg:col-span-2' : ''}
              `}
            >
              <div className={`
                ${index === 0 ? 'aspect-square' : 'aspect-square'}
                overflow-hidden
              `}>
                <img
                  src={image}
                  alt={`Gallery photo ${index + 1}`}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
